import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import HomeHero from "@/components/home/HomeHero";
import FounderToolkitQuiz from "@/components/FounderToolkitQuiz";
import { useToolkitQuiz } from "@/hooks/useToolkitQuiz";

// Lazy-load below-the-fold sections to shrink initial bundle and improve LCP/FCP
const HomeStats = lazy(() => import("@/components/home/HomeStats"));
const AnyaStory = lazy(() => import("@/components/home/AnyaStory"));
const HowItWorks = lazy(() => import("@/components/home/HowItWorks"));
const ToolsTeaser = lazy(() => import("@/components/home/ToolsTeaser"));

const Newsletter = lazy(() => import("@/components/home/Newsletter"));
const HomeFooter = lazy(() => import("@/components/home/HomeFooter"));

const Home = () => {
  const { open, close } = useToolkitQuiz();
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Co-Found with AI — The Founder Toolkit"
        description="Ship your startup solo. 80+ sequenced AI prompts take you from idea to launch — no team, no budget, no guesswork."
        path="/"
      />
      <Navbar />
      <main>
        <HomeHero />
        <Suspense fallback={null}>
          <HomeStats />
          <AnyaStory />
          <HowItWorks />
          <ToolsTeaser />
          <Newsletter />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <HomeFooter />
      </Suspense>
      <FounderToolkitQuiz open={open} onClose={close} />
    </div>
  );
};

export default Home;
